// extracted by mini-css-extract-plugin
export default {"pageTitle":"NJRContactUs_pageTitle__rV6uE","contactDet":"NJRContactUs_contactDet__gkU2f"};